import { useMatch } from 'react-router';

export const useCustomParamsFromUrl = (url: string) => {
    const match = useMatch(url);
    return match?.params;
};
